import React from "react";
import {
  Modal, Box, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem
} from "@mui/material";
import dayjs from "dayjs";

const AddEventModal = ({ open, onClose, onSave, eventData, setEventData, users }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="add-event-modal">
      <Box
        sx={{
          position: "absolute", top: "50%", left: "50%",
          transform: "translate(-50%, -50%)", width: 400,
          backgroundColor: "white", padding: 4, borderRadius: 2, boxShadow: 24
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>Add New Event</Typography>
        <TextField
          fullWidth label="Event Title"
          value={eventData.title}
          onChange={(e) => setEventData((prev) => ({ ...prev, title: e.target.value }))}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth type="datetime-local" label="Start Time"
          value={eventData.start ? dayjs(eventData.start).format("YYYY-MM-DDTHH:mm") : ""}
          onChange={(e) => setEventData((prev) => ({ ...prev, start: new Date(e.target.value) }))}
          sx={{ mb: 2 }}
        />
        <TextField
          fullWidth type="datetime-local" label="End Time"
          value={eventData.end ? dayjs(eventData.end).format("YYYY-MM-DDTHH:mm") : ""}
          onChange={(e) => setEventData((prev) => ({ ...prev, end: new Date(e.target.value) }))}
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="assign-label">Assign To</InputLabel>
          <Select
            labelId="assign-label"
            value={eventData.assigned_to_user_id}
            onChange={(e) =>
              setEventData((prev) => ({ ...prev, assigned_to_user_id: e.target.value }))
            }
          >
            {users.map((user) => (
              <MenuItem key={user.UserID} value={user.UserID}>
                {user.Name} {user.Lastname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth label="Description" multiline rows={3}
          value={eventData.description}
          onChange={(e) => setEventData((prev) => ({ ...prev, description: e.target.value }))}
          sx={{ mb: 2 }}
        />
        <Button fullWidth variant="contained" onClick={onSave}>
          Save Event
        </Button>
      </Box>
    </Modal>
  );
};

export default AddEventModal;
